import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';

type ChangeUserOrganizationParams = {
  userId: number;
  organizationId: number;
};

async function changeUserOrganization({
  userId,
  organizationId,
}: ChangeUserOrganizationParams): Promise<void> {
  await put(`/api/users/${userId}`, { organizationId });
}

/**
 * Hook to change a user's organization.
 * @param onSuccessCallback - Optional callback to execute after successful organization change
 * @returns Mutation function to change user organization
 */
export const useChangeUserOrganization = (onSuccessCallback?: () => void) => {
  return useToastedMutation({
    mutationFn: changeUserOrganization,
    successToastMessage: 'Organization changed successfully',
    errorToastMessage: 'Failed to change organization',
    onSuccess: () => {
      // Invalidate relevant queries
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      queryClient.invalidateQueries({ queryKey: ['user'] });

      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
  });
};
